import { useContext } from 'react';
import { CurrentPopupContext } from './context';
import { PopupApi } from './Popup/type';

export function useCurrentPopup<CTX = any>(): PopupApi<CTX> {
  const context = useContext(CurrentPopupContext);

  if (!context) {
    throw new Error('useCurrentPopup is not used inside a CurrentPopupContext');
  }

  return context;
}

export function useClosePopup() {
  const popup = useCurrentPopup();
  if (popup && popup.close) return popup.close;
  return () => {};
}
